export default {
  titles: {
    subscription: {
      en: '{size}-month plan',
    },
    card: {
      en: 'Gift card',
    },
    giftSubscription: {
      en: '{size}-month gift',
    },
  },
  discount: {
    en: 'Save ${discount}',
  },
  hint: {
    en: 'Free shipping',
  },
  bestseller: {
    en: 'bestseller',
  },
  buttonTitle: {
    en: 'Order now',
  },
  selectedButtonTitle: {
    en: 'Your plan',
  },
}
